import React, { useEffect, useRef } from "react";
import Close from "../components/FiraIcons/Close";

interface Props {
  open: boolean;
  onClose: () => void;
  children: React.ReactNode;
  haveHeader?: boolean;
  title?: string;
  // future: pass store data, callbacks, etc.
}

const overlayStyle: React.CSSProperties = {
  position: "fixed",
  inset: 0,
  backgroundColor: "rgba(0,0,0,0.4)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 1000,
};

const dialogStyle: React.CSSProperties = {
  width: 560,
  maxWidth: "95%",
  background: "#fff",
  borderRadius: 8,
  padding: 20,
  boxShadow: "0 10px 30px rgba(0,0,0,0.15)",
};

const headerStyle: React.CSSProperties = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  marginBottom: 12,
};

const closeButtonStyle: React.CSSProperties = {
  border: "none",
  background: "transparent",
  cursor: "pointer",
  fontSize: 18,
  lineHeight: 1,
};

export default function DialogLayout({
  open,
  onClose,
  children,
  haveHeader = true,
  title = "Modal Dialog",
}: Props) {
  const dialogRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (!open) return;

    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") onClose();
    };
    document.addEventListener("keydown", onKey);
    // simple focus: move focus to dialog for accessibility
    const prevActive = document.activeElement as HTMLElement | null;
    dialogRef.current?.focus();

    return () => {
      document.removeEventListener("keydown", onKey);
      prevActive?.focus();
    };
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div
      role="dialog"
      aria-modal="true"
      aria-label={title}
      style={overlayStyle}
      onMouseDown={(e) => {
        // close when clicking outside the dialog
        if (e.target === e.currentTarget) onClose();
      }}
    >
      <div ref={dialogRef} style={dialogStyle} tabIndex={-1}>
        {haveHeader && (
          <div style={headerStyle}>
            <h2 style={{ margin: 0, fontSize: 18 }}>{title}</h2>
            <button
              aria-label="Close"
              onClick={onClose}
              style={closeButtonStyle}
            >
              <Close />
            </button>
          </div>
        )}
        {children}
      </div>
    </div>
  );
}
